import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import React from "react";

import { leftMenuStore } from "../../leftMenuStore";
import * as styles from "./LeftMenuButtonTrigger.module.less";

export const LeftMenuButtonTrigger = observer(() => (
  <button
    type="button"
    className={styles.menuButtonTrigger}
    onClick={() => leftMenuStore.setIsOpen(!leftMenuStore.isOpen)}
  >
    {leftMenuStore.isOpen ? <CloseOutlined /> : <MenuOutlined />}
  </button>
));
